module.exports = __webpack_public_path__ + "static/img/fct-3.46faedb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/fct-3.png
// module id = AGMm
// module chunks = 63